export default {
  radioBoxGroup: {
    display: 'flex',
    flexDirection: 'row',
  },
};
